(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-collection"]) return;
  try {
    
  function initCgFacets() {
    const form = document.getElementById('cgFacets');
    if (!form || form.__cgFacets) return;
    form.__cgFacets = true;

    // Checkboxes apply immediately; price needs its own Apply button since
    // submitting mid-typing would reload on every keystroke.
    form.querySelectorAll('[data-auto-submit]').forEach((input) => {
      input.addEventListener('change', () => form.submit());
    });

    // Close an open filter panel when clicking elsewhere.
    document.addEventListener('click', (e) => {
      form.querySelectorAll('.cg-facets__group[open]').forEach((d) => {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });

    form.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      form.querySelectorAll('.cg-facets__group[open]').forEach((d) => d.removeAttribute('open'));
    });
  }

  document.addEventListener('DOMContentLoaded', initCgFacets);
  document.addEventListener('shopify:section:load', initCgFacets);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-contact"] && !Shopify.designMode) return;
  try {
    
  function initCgContactTabs() {
    document.querySelectorAll('.cg-contact__tabs').forEach((tabs) => {
      if (tabs.__cgTabs) return;
      tabs.__cgTabs = true;

      const wrap = tabs.closest('.cg-contact__form-wrap');
      const form = wrap.querySelector('form');
      if (!form) return;

      const buttons = [...tabs.querySelectorAll('.cg-contact__tab')];
      const typeField = form.querySelector('[data-inquiry-type]');
      // Every label that reads differently per tab, not just the message one.
      const swapLabels = [...form.querySelectorAll('label[data-label-general]')];

      const LABELS = {
        general: 'General / Order Inquiry',
        b2b: 'B2B / Wholesale',
      };

      function select(name) {
        buttons.forEach((btn) => {
          const on = btn.dataset.tab === name;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-selected', String(on));
          btn.tabIndex = on ? 0 : -1;
        });

        form.querySelectorAll('[data-tab-fields]').forEach((group) => {
          const on = group.dataset.tabFields === name;
          group.hidden = !on;
          // Disabled as well as hidden: a hidden-but-enabled required field
          // blocks submission with a validation error the user can't see.
          group.querySelectorAll('input, select, textarea').forEach((field) => {
            field.disabled = !on;
          });
        });

        if (typeField) typeField.value = LABELS[name] || LABELS.general;

        swapLabels.forEach((label) => {
          const next = name === 'b2b' ? label.dataset.labelB2b : label.dataset.labelGeneral;
          if (!next) return;
          // Preserve the trailing "(optional)" span some labels carry.
          const extra = label.querySelector('span');
          label.textContent = next;
          if (extra) label.appendChild(extra);
        });
      }

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => select(btn.dataset.tab));
      });

      // Arrow keys move between tabs, per the tablist pattern.
      tabs.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const i = buttons.findIndex((b) => b.classList.contains('is-active'));
        const next = event.key === 'ArrowRight' ? i + 1 : i - 1;
        const btn = buttons[(next + buttons.length) % buttons.length];
        select(btn.dataset.tab);
        btn.focus();
      });

      // Stops a double submit from a slow network looking like a dead button.
      form.addEventListener('submit', () => {
        const submit = form.querySelector('.cg-contact__submit');
        if (submit) setTimeout(() => { submit.disabled = true; }, 0);
      });

      select('general');
    });
  }

  document.addEventListener('DOMContentLoaded', initCgContactTabs);
  document.addEventListener('shopify:section:load', initCgContactTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-features"] && !Shopify.designMode) return;
  try {
    
  // Native scroll containers only respond to touch drag, horizontal trackpad
  // gestures or shift+wheel — a mouse has no way to grab them. On a desktop
  // browser at phone width the carousel therefore looks broken. This adds
  // click-drag for MOUSE ONLY; touch is left to native scrolling so we don't
  // fight the browser's momentum and snap physics on real devices.
  function initCgFeatureDrag() {
    document.querySelectorAll('.cg-features--mobile-carousel .cg-feature-grid').forEach((track) => {
      if (track.__cgDrag) return;
      track.__cgDrag = true;

      let dragging = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        if (track.scrollWidth <= track.clientWidth) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        // Snap fights manual scrollLeft writes mid-drag; restored on release
        // so it still settles onto a card.
        track.style.scrollSnapType = 'none';
        track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = startScroll - dx;
      });

      const release = () => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        track.style.scrollSnapType = '';
      };

      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);
      track.addEventListener('pointerleave', release);

      // A drag that ends on a link shouldn't also count as a click.
      track.addEventListener('click', (e) => {
        if (!moved) return;
        e.preventDefault();
        e.stopPropagation();
      }, true);

      // Dragging an image is the browser default and hijacks the gesture.
      track.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }

  document.addEventListener('DOMContentLoaded', initCgFeatureDrag);
  document.addEventListener('shopify:section:load', initCgFeatureDrag);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-header"]) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.cg-header').forEach((header) => {
        if (header.__cgHeader) return;
        header.__cgHeader = true;

        // Publish the header's real height so overlay mode can cancel it out.
        // Measured rather than hardcoded: it changes with fonts, logo and breakpoint.
        const publishHeight = () =>
          document.documentElement.style.setProperty('--cg-header-h', `${header.offsetHeight}px`);
        publishHeight();
        if ('ResizeObserver' in window) new ResizeObserver(publishHeight).observe(header);
        else addEventListener('resize', publishHeight, { passive: true });

        if (header.dataset.overlay === 'true') {
          // Go solid once the announcement bar has scrolled past.
          const trigger = () => {
            // The announcement bar is the section *before* this one, so walk
            // out to the section wrapper first.
            const above = header.closest('.shopify-section')?.previousElementSibling?.offsetHeight ?? 0;
            return above + 20;
          };
          const onScroll = () => header.classList.toggle('is-scrolled', scrollY > trigger());
          addEventListener('scroll', onScroll, { passive: true });
          onScroll();
        }

        const burger = header.querySelector('.cg-header__burger');
        const panel = header.querySelector('.cg-header__mobile');
        burger?.addEventListener('click', () => {
          const open = burger.getAttribute('aria-expanded') === 'true';
          burger.setAttribute('aria-expanded', String(!open));
          panel.hidden = open;
        });
      });

      initSearch();
    }

    function initSearch() {
      const overlay = document.querySelector('[data-search-overlay]');
      if (!overlay || overlay.__cgSearch) return;
      overlay.__cgSearch = true;

      const input = overlay.querySelector('[data-search-input]');
      const output = overlay.querySelector('[data-search-output]');
      const idlePanel = overlay.querySelector('[data-search-idle]');
      let lastFocus = null;
      let controller = null;
      let debounce = null;

      // Idle merchandising shows only while the field is empty.
      const showIdle = (on) => {
        if (idlePanel) idlePanel.hidden = !on;
        if (on) output.innerHTML = '';
      };

      const open = () => {
        lastFocus = document.activeElement;
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
        input.focus();
      };

      const close = () => {
        overlay.hidden = true;
        document.body.style.overflow = '';
        input.value = '';
        controller?.abort();
        showIdle(true);
        lastFocus?.focus();
      };

      document.querySelectorAll('[data-search-open]').forEach((b) => b.addEventListener('click', open));

      // Popular-search chips run the query inline instead of navigating away.
      overlay.querySelectorAll('[data-search-term]').forEach((chip) => {
        chip.addEventListener('click', (e) => {
          e.preventDefault();
          input.value = chip.dataset.searchTerm;
          input.focus();
          input.dispatchEvent(new Event('input'));
        });
      });
      overlay.querySelectorAll('[data-search-close]').forEach((b) => b.addEventListener('click', close));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !overlay.hidden) close();
      });

      // Keep tab focus inside the dialog while it is open.
      overlay.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        const focusables = overlay.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      const search = async (term) => {
        // Abort the in-flight request so a slow early keystroke can't
        // overwrite results for a later one.
        controller?.abort();
        controller = new AbortController();
        output.setAttribute('aria-busy', 'true');

        const url = `${window.Shopify?.routes?.root || '/'}search/suggest`
          + `?q=${encodeURIComponent(term)}`
          + `&resources[type]=product,collection,query`
          + `&resources[limit]=6`
          + `&section_id=cg-predictive-search`;

        try {
          const res = await fetch(url, { signal: controller.signal });
          if (!res.ok) throw new Error(res.status);
          const html = await res.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const results = parsed.querySelector('[data-predictive-results]');
          if (results) {
            showIdle(false);
            output.innerHTML = results.innerHTML;
          }
        } catch (err) {
          if (err.name !== 'AbortError') {
            showIdle(false);
            // {% raw %}{% javascript %}{% endraw %} blocks are static assets, not Liquid, so the
            // `t` filter can't run here — the markup hands the string over.
            const message = overlay.dataset.errorText || '';
            output.innerHTML = `<p class="cg-ps__empty-line">${message}</p>`;
          }
        } finally {
          output.setAttribute('aria-busy', 'false');
        }
      };

      input.addEventListener('input', () => {
        const term = input.value.trim();
        clearTimeout(debounce);
        if (term.length < 2) {
          controller?.abort();
          showIdle(true);
          output.setAttribute('aria-busy', 'false');
          return;
        }
        debounce = setTimeout(() => search(term), 200);
      });
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  // Horizon keeps its cart count in <cart-icon>, which owns the bubble markup
  // and refs we don't render — our header shows plain "Bag (n)" text. Nothing
  // updated it before, because add-to-cart used to be a full page navigation.
  (function () {
    if (window.__cgCartCountBound) return;
    window.__cgCartCountBound = true;

    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = String(n);
        // The desktop label reads "Bag (0)" quite happily, but a badge sitting
        // on an empty bag icon is just noise.
        if (el.classList.contains('cg-header__cart-count')) el.hidden = n === 0;
      });
    }

    document.addEventListener('cart:update', (event) => {
      const count = event.detail?.resource?.item_count;
      // Some emitters pass only a delta in data.itemCount, so when the full
      // cart isn't attached, ask the cart for the real total.
      if (typeof count === 'number') return setCount(count);

      const base = window.Theme?.routes?.cart_url || '/cart';
      fetch(base + '.js')
        .then((r) => r.json())
        .then((cart) => setCount(cart.item_count))
        .catch(() => {});
    });
  })();

  // Lives in the header because it must run on every page: a section's
  // {% raw %}{% javascript %}{% endraw %} only loads where that section renders, and the cards
  // this serves appear on collections and search, not just the carousel.
  // Add to cart is a fetch and Buy It Now is a redirect; both leave the button
  // looking idle while they work. One delegated handler covers every path —
  // cards, the PDP button and the sticky bar all go through the same form —
  // so nothing has to be bound per card.
  (function () {
    if (window.__cgAtcLoading) return;
    window.__cgAtcLoading = true;

    const CLASS = 'cg-is-loading';
    const timers = new WeakMap();

    function start(btn) {
      if (!btn || btn.disabled || btn.classList.contains(CLASS)) return;
      btn.classList.add(CLASS);
      btn.setAttribute('aria-busy', 'true');
      // A button that spins forever reads worse than one that never spun, so
      // a failed request that never reports back still resolves.
      clearTimeout(timers.get(btn));
      timers.set(btn, setTimeout(() => stop(btn), 10000));
    }

    function stop(btn) {
      clearTimeout(timers.get(btn));
      btn.classList.remove(CLASS);
      btn.removeAttribute('aria-busy');
    }

    function stopAll() {
      document.querySelectorAll('.' + CLASS).forEach(stop);
    }

    // Capture, so this runs before the handler that cancels the native submit.
    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.dataset.type !== 'add-to-cart-form') return;
        form.querySelectorAll('button[type="submit"]').forEach(start);
      },
      true
    );

    // Buy It Now and the sticky bar are plain buttons, so no submit event
    // names them — the sticky one submits the form from outside it.
    document.addEventListener('click', (event) => {
      start(event.target.closest?.('[data-buy-now], [data-sticky-atc-submit]'));
    });

    // The drawer opening is what "done" actually means for add to cart.
    document.addEventListener('cart:update', stopAll);
    // Buy It Now navigates away; a back-button restore would otherwise bring
    // back a button still mid-spin.
    addEventListener('pageshow', stopAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-hero"] && !Shopify.designMode) return;
  try {
    
  /* Hero background videos fade in over the poster image once playback
     actually starts. A video that never plays (slow network, blocked
     autoplay) simply never reveals itself — the image stays. */
  const initCgHeroVideos = () => {
    document.querySelectorAll('.cg-hero__video').forEach((v) => {
      if (v.__cgFade) return;
      v.__cgFade = true;
      const show = () => { if (!v.paused) v.classList.add('is-playing'); };
      if (!v.paused && v.readyState >= 3) v.classList.add('is-playing');
      v.addEventListener('playing', show);
      v.addEventListener('timeupdate', show);
      v.addEventListener('loadeddata', show);

      /* iOS Safari ignores the autoplay attribute more often than desktop
         browsers: the muted attribute can be dropped from the playback
         policy check, and Low Power Mode (very common on iPhones) defers
         every autoplay until a gesture. Set the muted property explicitly,
         nudge play(), retry once the file can play, and retry on the first
         touch so Low Power Mode users get the video after their first tap. */
      const kick = () => {
        if (!v.paused) return;
        v.muted = true;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      };
      kick();
      v.addEventListener('canplay', kick);
      const retry = { once: true, passive: true };
      addEventListener('touchstart', kick, retry);
      addEventListener('pointerdown', kick, retry);
    });
  };
  document.addEventListener('DOMContentLoaded', initCgHeroVideos);
  document.addEventListener('shopify:section:load', initCgHeroVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

    // CARTO Voyager: a standard full-colour basemap. Free, keyless, and CDN
    // backed — unlike tile.openstreetmap.org, whose usage policy asks
    // commercial sites not to hit it directly.
    const TILE_URL = 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
    const ATTRIBUTION =
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';

    let loader = null;
    function loadLeaflet() {
      if (window.L) return Promise.resolve();
      if (!loader) {
        loader = new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = LEAFLET_JS;
          s.async = true;
          s.onload = resolve;
          s.onerror = reject;
          document.head.appendChild(s);
        });
      }
      return loader;
    }

    function build(el) {
      const lat = parseFloat(el.dataset.lat);
      const lng = parseFloat(el.dataset.lng);
      if (Number.isNaN(lat) || Number.isNaN(lng)) return;

      const map = L.map(el, {
        center: [lat, lng],
        zoom: parseInt(el.dataset.zoom, 10) || 14,
        // Otherwise scrolling the page gets captured by the map.
        scrollWheelZoom: false
      });

      L.tileLayer(TILE_URL, {
        attribution: ATTRIBUTION,
        subdomains: 'abcd',
        maxZoom: 20
      }).addTo(map);

      L.marker([lat, lng], {
        title: el.dataset.label || '',
        icon: L.divIcon({
          className: '',
          html: '<span class="cg-map__marker"></span>',
          iconSize: [16, 16],
          iconAnchor: [8, 8]
        })
      }).addTo(map);

      map.on('click', () => map.scrollWheelZoom.enable());

      // Leaflet mis-measures if the container resizes after init.
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => map.invalidateSize()).observe(el);
      }
    }

    function init() {
      const nodes = document.querySelectorAll('[data-cg-map]');
      if (!nodes.length) return;
      loadLeaflet()
        .then(() => nodes.forEach((el) => {
          if (el.__cgMap) return;
          el.__cgMap = true;
          build(el);
        }))
        .catch(() => {
          // Address card beside the map still carries the useful information.
        });
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-marquee"] && !Shopify.designMode) return;
  try {
    
  class CgMarquee {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-marquee-track]');
      this.seed = root.querySelector('[data-marquee-group]');
      if (!this.track || !this.seed) return;

      this.pxPerSecond = parseFloat(root.dataset.speed) || 60;
      this.build = this.build.bind(this);

      // Fonts change item widths, which changes how many copies we need.
      if (document.fonts?.ready) document.fonts.ready.then(this.build);
      this.build();

      let t;
      addEventListener('resize', () => { clearTimeout(t); t = setTimeout(this.build, 150); }, { passive: true });
    }

    build() {
      // Reset to the single seed group before re-measuring.
      this.track.replaceChildren(this.seed);

      const groupWidth = this.seed.offsetWidth;
      if (!groupWidth) return;

      // Enough copies that one "set" always overflows the viewport, so the
      // strip never runs out mid-loop on a wide screen.
      const copies = Math.max(2, Math.ceil(this.root.offsetWidth / groupWidth) + 1);
      const set = document.createDocumentFragment();
      for (let i = 1; i < copies; i++) {
        const clone = this.seed.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-marquee-group');
        set.appendChild(clone);
      }
      this.track.appendChild(set);

      // Mirror the whole set — translating -50% then lands exactly on a repeat.
      const setWidth = groupWidth * copies;
      [...this.track.children].forEach((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-marquee-group');
        this.track.appendChild(clone);
      });

      // Duration from distance, so speed reads the same no matter how much
      // content there is.
      this.track.style.setProperty('--cg-marquee-duration', `${setWidth / this.pxPerSecond}s`);
    }
  }

  function initCgMarquee() {
    document.querySelectorAll('[data-marquee]').forEach((el) => {
      if (!el.__cgMarquee) el.__cgMarquee = new CgMarquee(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initCgMarquee);
  document.addEventListener('shopify:section:load', initCgMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-product-carousel"] && !Shopify.designMode) return;
  try {
    
class CgCarousel {
    constructor(section) {
      this.section = section;
      this.root = section.querySelector('[data-carousel]');
      this.track = section.querySelector('[data-track]');
      this.fill = section.querySelector('[data-fill]');
      this.slides = [...this.track.children];
      if (!this.slides.length) return;

      this.GAP = 32;
      this.autoplayMs = parseInt(section.dataset.autoplay, 10) || 0;
      this.index = 0;
      this.currentOffset = 0; // Tracks the exact free-scroll pixel position
      this.slideW = 0;
      this.timer = null;
      this.hovered = false;

      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.layout = this.layout.bind(this);
      this.layout();
      addEventListener('resize', this.layout, { passive: true });

      this.bindDrag();
      this.bindBadge();

      new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting && !this.hovered ? this.play() : this.pause()));
      }, { threshold: 0.4 }).observe(this.root);
    }

    get visible() {
      const w = innerWidth;
      const desktop = parseInt(this.section.dataset.visible, 10) || 3;
      if (w < 750) return 1;
      if (w < 990) return 2;
      return desktop;
    }

    get peek() {
      const raw = parseInt(this.section.dataset.peek, 10);
      const want = Number.isNaN(raw) ? 48 : raw;
      return Math.max(0, Math.min(want, this.root.offsetWidth * 0.25));
    }

    get step() { return this.slideW + this.GAP; }

    get maxScroll() {
      const trackW = this.slides.length * this.slideW + (this.slides.length - 1) * this.GAP;
      return Math.max(0, trackW - this.root.offsetWidth);
    }

    get maxIndex() {
      if (this.step <= 0) return 0;
      return Math.max(0, Math.ceil(this.maxScroll / this.step));
    }

    offsetFor(i) {
      return Math.min(Math.max(0, i) * this.step, this.maxScroll);
    }

    layout() {
      const v = this.visible;
      this.slideW = (this.root.offsetWidth - this.GAP * v - this.peek) / v;
      /* Cached: reading it per touchmove forced a style recalc mid-gesture. */
      this.dir = getComputedStyle(this.root).direction === 'rtl' ? 1 : -1;
      this.slides.forEach((s) => (s.style.width = `${this.slideW}px`));
      this.index = Math.min(this.index, this.maxIndex);
      this.currentOffset = this.offsetFor(this.index);
      this.render();
    }

    render(animate = false, animClass = 'is-animating') {
      this.track.classList.toggle(animClass, animate && !this.reduced);
      if (!animate) this.track.classList.remove('is-animating', 'is-settling');
      this.track.style.transform = `translate3d(${this.dir * this.currentOffset}px,0,0)`;
      if (this.fill) {
        const pct = this.maxScroll === 0 ? 100 : (this.currentOffset / this.maxScroll) * 100;
        this.fill.style.width = `${pct}%`;
      }
    }

    goTo(i, animate = true, animClass = 'is-animating') {
      this.index = Math.max(0, Math.min(i, this.maxIndex));
      this.currentOffset = this.offsetFor(this.index);
      this.render(animate, animClass);
      if (animClass === 'is-settling' && animate && !this.reduced) {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.track.classList.remove('is-settling'), 350);
      }
    }

    play() {
      this.pause();
      if (!this.autoplayMs || this.reduced) return;
      this.timer = setInterval(() => {
        this.goTo(this.index >= this.maxIndex ? 0 : this.index + 1);
      }, this.autoplayMs);
    }

    pause() { clearInterval(this.timer); this.timer = null; }

    bindDrag() {
      let startX = 0, delta = 0, dragging = false, moved = false;
      let startOffset = 0;
      let raf = 0;
      let lastX = 0, lastT = 0, velocity = 0; /* px/ms, screen space */

      /* Where the track actually is right now. During an autoplay glide the
         logical offset is already the target, so grabbing must freeze the
         visual position — otherwise the track teleports on touch. */
      const visualOffset = () => {
        const t = getComputedStyle(this.track).transform;
        if (!t || t === 'none') return 0;
        const m3 = t.match(/matrix3d\(([^)]+)\)/);
        const m = t.match(/matrix\(([^)]+)\)/);
        const tx = m3 ? parseFloat(m3[1].split(',')[12]) : m ? parseFloat(m[1].split(',')[4]) : 0;
        return Math.max(0, Math.min((tx || 0) * this.dir, this.maxScroll));
      };

      const down = (x) => {
        dragging = true; startX = x; delta = 0; moved = false;
        lastX = x; lastT = performance.now(); velocity = 0;
        this.currentOffset = visualOffset();
        startOffset = this.currentOffset;
        this.pause();
        this.track.classList.remove('is-animating', 'is-settling');
        this.track.style.transform = `translate3d(${this.dir * this.currentOffset}px,0,0)`;
        this.root.classList.add('is-dragging');
      };
      const move = (x) => {
        if (!dragging) return;
        delta = x - startX;
        const now = performance.now();
        if (now > lastT) {
          /* Smoothed release velocity — cheap to update, kept out of the
             rAF gate so a fast flick never samples a stale finger. */
          velocity = velocity * 0.8 + ((x - lastX) / (now - lastT)) * 0.2;
          lastX = x; lastT = now;
        }
        if (Math.abs(delta) > 3) moved = true;
        if (raf) return; /* Coalesce: one transform write per frame. */
        raf = requestAnimationFrame(() => {
          raf = 0;
          if (!dragging) return;
          const rawOffset = startOffset + delta * this.dir;
          this.currentOffset = Math.max(0, Math.min(rawOffset, this.maxScroll));
          this.render(false);
        });
      };
      const release = () => {
        if (!dragging) return;
        dragging = false;
        cancelAnimationFrame(raf);
        raf = 0;
        this.root.classList.remove('is-dragging');

        if (performance.now() - lastT > 90) velocity = 0;
        /* Fold in the last queued frame first — rounding from a stale
           position lands snaps on the wrong card. Then project the flick:
           a fast release keeps travelling before it rounds, capped at two
           cards so it stays controllable. */
        this.currentOffset = Math.max(0, Math.min(startOffset + delta * this.dir, this.maxScroll));

        if (moved) {
          const nearest = Math.round(this.currentOffset / this.step);
          const projected = this.currentOffset + velocity * this.dir * 280;
          const target = Math.max(nearest - 2, Math.min(nearest + 2, Math.round(projected / this.step)));
          this.goTo(target, !this.reduced, 'is-settling');
        } else {
          /* A tap — or a slow drag the browser cancelled for vertical drift
             before it moved far. Glide back to the current card; never
             revert as if the drag never happened. */
          this.goTo(this.index, true);
        }
        if (!this.hovered) this.play();
      };

      this.root.addEventListener('mousedown', (e) => { e.preventDefault(); down(e.clientX); });
      addEventListener('mousemove', (e) => move(e.clientX));
      addEventListener('mouseup', release);
      this.root.addEventListener('touchstart', (e) => down(e.touches[0].clientX), { passive: true });
      this.root.addEventListener('touchmove', (e) => move(e.touches[0].clientX), { passive: true });
      this.root.addEventListener('touchend', release);
      this.root.addEventListener('touchcancel', release);

      this.root.addEventListener(
        'click',
        (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      this.root.tabIndex = 0;
      this.root.setAttribute('role', 'region');
      this.root.setAttribute('aria-label', 'Product carousel');
      this.root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
      });
    }

    bindBadge() {
      if (matchMedia('(pointer: coarse)').matches) return;

      let badge = document.querySelector('.cg-swipe-badge');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'cg-swipe-badge';
        badge.textContent = 'swipe';
        document.body.appendChild(badge);
      }

      let x = 0, y = 0, tx = 0, ty = 0, raf = null;
      const follow = () => {
        x += (tx - x) * 0.12;
        y += (ty - y) * 0.12;
        badge.style.translate = `${x}px ${y}px`;
        raf = requestAnimationFrame(follow);
      };

      this.root.addEventListener('mouseenter', (e) => {
        this.hovered = true;
        tx = x = e.clientX; ty = y = e.clientY;
        badge.style.translate = `${x}px ${y}px`;
        badge.classList.add('is-visible');
        this.pause();
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(follow);
      });
      this.root.addEventListener('mousemove', (e) => { tx = e.clientX; ty = e.clientY; });
      this.root.addEventListener('mouseleave', () => {
        this.hovered = false;
        badge.classList.remove('is-visible');
        cancelAnimationFrame(raf);
        this.play();
      });
    }
  }

  function initCgCarousels() {
    document.querySelectorAll('.cg-carousel-section').forEach((s) => {
      if (!s.__cgCarousel) s.__cgCarousel = new CgCarousel(s);
    });
  }

  document.addEventListener('DOMContentLoaded', initCgCarousels);
  document.addEventListener('shopify:section:load', initCgCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-product-hero"]) return;
  try {
    
  function initCgPdp() {
    const section = document.getElementById('cgPdpHero');
    if (!section || section.__cgPdp) return;
    section.__cgPdp = true;

    const form = document.getElementById('cgPdpForm');
    const variantInput = form?.querySelector('[data-variant-input]');
    const qtyInput = form?.querySelector('[data-qty-input]');
    const qtyValue = form?.querySelector('[data-qty-value]');
    const priceEl = section.querySelector('[data-price]');

    let qty = 1;
    const setQty = (n) => {
      qty = Math.max(1, n);
      if (qtyValue) qtyValue.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      const stickyVal = document.querySelector('[data-sticky-qty-value]');
      if (stickyVal) stickyVal.textContent = qty;
    };
    // form.submit() bypasses submit listeners, so this escapes the AJAX
    // handler. `name="checkout"` only redirects on the cart form; the product
    // form posts to /cart/add, where `return_to` is what picks the next page.
    section.querySelector('[data-buy-now]')?.addEventListener('click', () => {
      if (!form) return;
      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      field.value = '/checkout';
      form.appendChild(field);
      form.submit();
    });

    section.querySelector('[data-qty-minus]')?.addEventListener('click', () => setQty(qty - 1));
    section.querySelector('[data-qty-plus]')?.addEventListener('click', () => setQty(qty + 1));
    document.querySelector('[data-sticky-qty-minus]')?.addEventListener('click', () => setQty(qty - 1));
    document.querySelector('[data-sticky-qty-plus]')?.addEventListener('click', () => setQty(qty + 1));

    // Variant options: pill buttons update the hidden variant id + price.
    // Reads variant JSON already present in the page via {{ product | json }}
    // would duplicate payload; instead this walks the option buttons and
    // asks Shopify's variant data embedded per-option — simplest robust
    // approach without a second fetch is to keep a small variants map.
    const variantsData = window.__cgProductVariants || [];
    const selected = {};

    section.querySelectorAll('[data-option-index]').forEach((btn) => {
      const idx = btn.dataset.optionIndex;
      if (btn.classList.contains('is-active')) selected[idx] = btn.dataset.optionValue;

      btn.addEventListener('click', () => {
        const group = section.querySelectorAll(`[data-option-index="${idx}"]`);
        group.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        selected[idx] = btn.dataset.optionValue;

        const label = section.querySelector(`[data-option-label="${idx}"]`);
        if (label) label.textContent = btn.dataset.optionValue;

        const match = variantsData.find((v) =>
          v.options.every((opt, i) => selected[i] === undefined || selected[i] === opt)
        );
        if (match) {
          if (variantInput) variantInput.value = match.id;
          if (priceEl) priceEl.textContent = match.priceFormatted;
          const atc = section.querySelector('[data-atc]');
          if (atc) {
            atc.disabled = !match.available;
            atc.textContent = match.available
              ? atc.dataset.labelAdd || atc.textContent
              : atc.dataset.labelSoldOut || atc.textContent;
          }
        }
      });
    });

    // Sticky bar: visible once the hero has scrolled out of view.
    const sticky = document.querySelector('[data-sticky-atc]');
    if (sticky) {
      new IntersectionObserver(
        (entries) => entries.forEach((e) => sticky.classList.toggle('is-visible', !e.isIntersecting)),
        { rootMargin: '-100px 0px 0px 0px' }
      ).observe(section);

      sticky.querySelector('[data-sticky-atc-submit]')?.addEventListener('click', () => {
        form?.requestSubmit();
      });
    }

    // Mobile turns the stacked gallery into a scroll-snap row (CSS only). This
    // just keeps the thumbnails and the swipe pointing at the same shot.
    const gallery = section.querySelector('.cg-pdp__gallery');
    const strip = section.querySelector('[data-pdp-thumbs]');
    const thumbs = strip ? [...strip.querySelectorAll('[data-pdp-thumb]')] : [];

    if (gallery && thumbs.length) {
      const shots = [...gallery.querySelectorAll('.cg-pdp__shot')];

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const shot = shots[Number(thumb.dataset.pdpThumb)];
          // Physical delta from the current position rather than an absolute
          // scrollLeft: under RTL scrollLeft counts down from 0, so an
          // offsetLeft-derived target lands on the wrong slide.
          if (!shot) return;
          const delta = shot.getBoundingClientRect().left - gallery.getBoundingClientRect().left;
          gallery.scrollBy({ left: delta, behavior: 'smooth' });
        });
      });

      const setActive = (index) => {
        thumbs.forEach((thumb, n) => thumb.classList.toggle('is-active', n === index));
        const active = thumbs[index];
        if (!active || !strip.clientWidth) return;
        // Centre it by hand — scrollIntoView would drag the page along with it.
        // Same reason as above: measure, then move by a physical delta.
        const stripRect = strip.getBoundingClientRect();
        const activeRect = active.getBoundingClientRect();
        strip.scrollBy({
          left: activeRect.left + activeRect.width / 2 - (stripRect.left + stripRect.width / 2),
          behavior: 'smooth',
        });
      };

      // Driven by what is on screen rather than by clicks, so a swipe moves the
      // thumbnails too. On desktop the gallery is a vertical column and the
      // thumbnails are hidden, which makes this harmless there.
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) setActive(shots.indexOf(entry.target));
          });
        },
        { root: gallery, threshold: 0.6 }
      );
      shots.forEach((shot) => observer.observe(shot));
    }

    // One row open at a time. The `name` attribute on <details> does this
    // natively, but it only groups siblings — these rows are split across
    // several `.cg-pdp__acc-group` wrappers, so they'd form separate groups.
    // `toggle` doesn't bubble, hence capture.
    const accordion = section.querySelector('.cg-pdp__accordion');
    accordion?.addEventListener(
      'toggle',
      (event) => {
        const opened = event.target;
        if (!opened.open) return;
        accordion.querySelectorAll('details[open]').forEach((other) => {
          if (other !== opened) other.open = false;
        });
      },
      true
    );

    // Native share sheet where available, clipboard fallback otherwise.
    section.querySelector('[data-share]')?.addEventListener('click', async () => {
      const shareData = { title: document.title, url: location.href };
      if (navigator.share) {
        navigator.share(shareData).catch(() => {});
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(location.href);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initCgPdp);
  document.addEventListener('shopify:section:load', initCgPdp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  function initCgReviews() {
    document.querySelectorAll('.cg-reviews').forEach((section) => {
      if (section.__cgReviews) return;
      section.__cgReviews = true;
      const track = section.querySelector('[data-rc-track]');
      if (!track) return;
      const step = () => track.querySelector('.cg-rc-card')?.offsetWidth + 28 || 388;
      // "Next" is physically leftward in RTL, so the arrows swap sign rather
      // than swapping which button is which.
      const dirSign = () => (getComputedStyle(track).direction === 'rtl' ? -1 : 1);
      section.querySelector('[data-rc-prev]')?.addEventListener('click', () =>
        track.scrollBy({ left: -step() * dirSign(), behavior: 'smooth' })
      );
      section.querySelector('[data-rc-next]')?.addEventListener('click', () =>
        track.scrollBy({ left: step() * dirSign(), behavior: 'smooth' })
      );
    });
  }
  document.addEventListener('DOMContentLoaded', initCgReviews);
  document.addEventListener('shopify:section:load', initCgReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-text-hover"] && !Shopify.designMode) return;
  try {
    
  class CgTextHover {
    constructor(section) {
      // Liquid already emitted the words and paired them with images; this
      // only adds the floating preview, which needs a pointer to follow.
      if (matchMedia('(pointer: coarse)').matches) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const words = section.querySelectorAll('.cg-hover-word[data-img]:not([data-img=""])');
      if (!words.length) return;

      this.tip = document.createElement('div');
      this.tip.className = 'cg-hover-tip';
      this.tip.innerHTML = '<img alt="">';
      document.body.appendChild(this.tip);
      this.tipImg = this.tip.querySelector('img');

      this.state = { rot: 0, x: 0, y: 0, scale: 0, vel: 0 };
      this.target = { rot: 0, x: 0, y: 0, scale: 0 };
      this.hovering = false;
      this.raf = null;

      words.forEach((w) => {
        w.addEventListener('mouseenter', () => {
          const r = w.getBoundingClientRect();
          this.tipImg.src = w.dataset.img;
          this.hovering = true;
          this.target.scale = 1;
          this.state.x = this.target.x = r.left + r.width / 2 - 80;
          this.state.y = this.target.y = r.top - 190;
          this.state.rot = this.target.rot = 0;
          this.tip.classList.add('is-visible');
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.tick());
        });
        w.addEventListener('mousemove', (e) => {
          const r = w.getBoundingClientRect();
          const progress = (e.clientX - r.left) / r.width;
          this.target.rot = -18 + progress * 36;
          this.target.x = e.clientX - 70;
          this.target.y = r.top - 190;
        });
        w.addEventListener('mouseleave', () => {
          this.hovering = false;
          this.target.scale = 0;
        });
      });
    }

    tick() {
      const s = this.state, t = this.target;
      // Springy scale in, softer out.
      const stiffness = this.hovering ? 0.18 : 0.06;
      const damping = this.hovering ? 0.68 : 0.82;
      s.vel += (t.scale - s.scale) * stiffness;
      s.vel *= damping;
      s.scale += s.vel;

      s.rot += (t.rot - s.rot) * 0.03;
      s.x += (t.x - s.x) * 0.05;
      s.y += (t.y - s.y) * 0.05;

      this.tip.style.translate = `${s.x}px ${s.y}px`;
      this.tip.style.rotate = `${s.rot.toFixed(3)}deg`;
      this.tip.style.scale = s.scale.toFixed(4);

      if (!this.hovering && s.scale < 0.01) {
        this.tip.classList.remove('is-visible');
        this.raf = null;
        return;
      }
      this.raf = requestAnimationFrame(() => this.tick());
    }
  }

  function initCgTextHover() {
    document.querySelectorAll('.cg-text-hover').forEach((s) => {
      if (!s.__cgTextHover) s.__cgTextHover = new CgTextHover(s);
    });
  }
  document.addEventListener('DOMContentLoaded', initCgTextHover);
  document.addEventListener('shopify:section:load', initCgTextHover);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-ugc-reels"] && !Shopify.designMode) return;
  try {
    
  function initReels() {
    document.querySelectorAll('.reel[data-has-video="true"]').forEach((reel) => {
      const video = reel.querySelector('.reel-video');
      const playBtn = reel.querySelector('.reel-play');
      const muteBtn = reel.querySelector('.reel-mute');
      if (!video || reel.__reelBound) return;
      reel.__reelBound = true;

      // Reflects the video's real state onto the reel, regardless of what
      // triggered it (hover preview or an explicit click) — the play/pause
      // icon is always accurate.
      video.addEventListener('play', () => { reel.dataset.playing = 'true'; });
      video.addEventListener('ended', () => { reel.dataset.playing = 'false'; });
      video.addEventListener('pause', () => {
        reel.dataset.playing = 'false';
        // Hand the audio slot back, so a paused reel isn't still holding it
        // and the next one played starts with sound.
        video.muted = true;
        reel.dataset.muted = 'true';
      });

      // Muted ambient preview on hover, same as before — but only until the
      // user takes explicit control via the play button. After that, hover
      // stops managing this reel; leaving the card shouldn't stop a video
      // someone deliberately started.
      //
      // Pointer devices only. A tap fires mouseenter *before* click, so on a
      // phone the preview would start the video and the play button would
      // then immediately pause it — the two handlers cancelled each other out
      // and the button looked broken.
      if (window.matchMedia('(hover: hover)').matches) {
        reel.addEventListener('mouseenter', () => {
          if (reel.dataset.userStarted === 'true') return;
          video.play?.().catch(() => {});
        });
        reel.addEventListener('mouseleave', () => {
          if (reel.dataset.userStarted === 'true') return;
          video.pause?.();
          video.currentTime = 0;
        });
      }

      // Only one reel is ever audible. Called whenever this one takes the
      // audio, so every other reel drops back to muted.
      function claimAudio() {
        document.querySelectorAll('.reel[data-has-video="true"]').forEach((other) => {
          if (other === reel) return;
          const otherVideo = other.querySelector('.reel-video');
          if (otherVideo) otherVideo.muted = true;
          other.dataset.muted = 'true';
        });
        video.muted = false;
        reel.dataset.muted = 'false';
      }

      playBtn.addEventListener('click', (event) => {
        // The button sits above `.reel-link`, but without this a click still
        // bubbles to the anchor and navigates away instead of toggling.
        event.preventDefault();
        event.stopPropagation();
        reel.dataset.userStarted = 'true';

        if (video.paused) {
          // Deliberate play means sound on. Unmuting is only allowed because
          // this runs inside a real click — autoplay policy blocks it
          // otherwise.
          claimAudio();
          video.play?.().catch(() => {});
        } else {
          video.pause?.();
        }
      });

      muteBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (video.muted) {
          claimAudio();
          reel.dataset.userStarted = 'true';
          if (video.paused) video.play?.().catch(() => {});
        } else {
          video.muted = true;
          reel.dataset.muted = 'true';
        }
      });
    });
  }
  // Prev/next buttons — desktop only (see the CSS comment on .ugc-nav for
  // why). Same dirSign() idiom as the reviews carousel: "next" is physically
  // leftward in RTL, so the arrows swap sign rather than swapping which
  // button does which.
  function initCgUgcNav() {
    document.querySelectorAll('.cg-ugc').forEach((section) => {
      if (section.__cgUgcNav) return;
      const track = section.querySelector('.ugc-grid');
      const prevBtn = section.querySelector('[data-ugc-prev]');
      const nextBtn = section.querySelector('[data-ugc-next]');
      if (!track || !prevBtn || !nextBtn) return;
      section.__cgUgcNav = true;

      const dirSign = () => (getComputedStyle(track).direction === 'rtl' ? -1 : 1);
      // Reads the real card width and gap rather than hardcoding either —
      // the gap differs between the mobile (12px) and desktop (16px) rules
      // above, and this way one step size is correct at both.
      const step = () => {
        const card = track.querySelector('.reel');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return (card?.offsetWidth || 300) + gap;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -step() * dirSign(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: step() * dirSign(), behavior: 'smooth' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initReels);
  document.addEventListener('shopify:section:load', initReels);
  document.addEventListener('DOMContentLoaded', initCgUgcNav);
  document.addEventListener('shopify:section:load', initCgUgcNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-usp-spotlight"] && !Shopify.designMode) return;
  try {
    
  class UspSpotlight {
    constructor(root) {
      this.root = root;
      this.items = [...root.querySelectorAll('.usp-item')];
      this.visuals = [...root.querySelectorAll('.usp-visual > *')];
      if (this.items.length < 2) return;

      this.duration = parseInt(root.dataset.duration, 10) || 3000;
      root.style.setProperty('--usp-duration', `${this.duration}ms`);
      this.index = 0;
      this.timer = null;
      this.paused = false;

      this.items.forEach((item, i) => {
        item.addEventListener('mouseenter', () => { this.paused = true; this.goTo(i); });
        item.addEventListener('mouseleave', () => { this.paused = false; this.queue(); });
      });

      // Only run while visible — no timers burning offscreen.
      new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? this.queue() : this.stop()));
      }, { threshold: 0.3 }).observe(root);
    }

    goTo(i) {
      this.stop();
      this.items[this.index]?.classList.remove('active');
      this.visuals[this.index]?.classList.remove('active');
      this.index = i % this.items.length;
      const item = this.items[this.index];
      item.classList.add('active');
      this.visuals[this.index]?.classList.add('active');

      // Restart the fill animation.
      const h3 = item.querySelector('h3');
      if (h3) { h3.style.animation = 'none'; void h3.offsetWidth; h3.style.animation = ''; }

      // queue() re-arms the timer for the *next* step. Without this, nothing
      // ever calls it again after the first advance — the observer only fires
      // once per visibility crossing, so autoplay took exactly one step and
      // stopped for good. Hovering still pauses it: queue() no-ops while
      // this.paused is true.
      this.queue();
    }

    queue() {
      this.stop();
      if (this.paused) return;
      this.timer = setTimeout(() => this.goTo(this.index + 1), this.duration);
    }

    stop() { clearTimeout(this.timer); this.timer = null; }
  }

  function initUsp() {
    document.querySelectorAll('.usp-section').forEach((el) => {
      if (!el.__usp) el.__usp = new UspSpotlight(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initUsp);
  document.addEventListener('shopify:section:load', initUsp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
